import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acb738ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("已付款")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("未付款")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("寄付现结"))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("到付"))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("司机 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("已卸货"))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  ref: "amap",
  style: {"height":"500px","width":"100%"},
  id: "amap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_man_outlined = _resolveComponent("man-outlined")!
  const _component_woman_outlined = _resolveComponent("woman-outlined")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "detail_content" }, {
      default: _withCtx(() => [
        (_ctx.detail)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 0,
              title: "基本信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "订单ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "流水号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.sn), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "订单状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tag, {
                      color: _ctx.getLogisticsOrderStatus(_ctx.detail?.status)?.color
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getLogisticsOrderStatus(_ctx.detail?.status)?.name), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "订单金额" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString("¥ " + _ctx.detail?.money), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "物流类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.expressTypes.find(item => item.id === _ctx.detail?.express_category_id)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车辆类型" }, {
                  default: _withCtx(() => [
                    (_ctx.carTypes.find(item => item.id === _ctx.detail?.vehicle_type))
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "blue"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.carTypes.find(item => item.id === _ctx.detail?.vehicle_type)?.name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "支付金额" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString("¥ " + _ctx.detail?.pay_amount), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "支付状态" }, {
                  default: _withCtx(() => [
                    (_ctx.detail?.pay_status)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "支付时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dateFormat(_ctx.detail?.pay_time * 1000)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "付费方式" }, {
                  default: _withCtx(() => [
                    (_ctx.detail?.payment_method === 1)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "pink"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "orange"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "优惠" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.discount_amount ? "¥ " + _ctx.detail?.discount_amount : "全款"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "尾款" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(Number(_ctx.detail?.charges) ? _ctx.detail?.charges : "一次性付清"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "下单时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.create_time), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "预订装货时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.ship_start_time + " - " + _ctx.detail?.ship_end_time), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "删除时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.delete_time), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_6,
        (_ctx.detail && _ctx.detail.receiver_user)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 1,
              title: "司机",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "头像" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image, {
                      src: _ctx.detail?.receiver_user?.head_img,
                      width: 50,
                      height: 50
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "姓名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.receiver_user?.name) + " ", 1),
                    (_ctx.detail?.receiver_user?.gender === 1)
                      ? (_openBlock(), _createBlock(_component_man_outlined, {
                          key: 0,
                          style: {"color":"deepskyblue"}
                        }))
                      : (_openBlock(), _createBlock(_component_woman_outlined, {
                          key: 1,
                          style: {"color":"deeppink"}
                        })),
                    _createVNode(_component_a_tag, { style: {"margin-left":"5px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.detail?.receiver_user?.stars_total /  _ctx.detail?.receiver_user?.consignment_total).toFixed(2)) + " ", 1),
                        _createVNode(_component_StarFilled, { style: {"color":"darkorange"} }),
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "联系电话" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.receiver_user?.phone), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.receiver_user?.user_id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "AdminID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.receiver_user?.shop_admin_id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车辆ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.car?.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车牌号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.car?.plate_number), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "货车类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.car?.car_type), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_8,
        (_ctx.detail && _ctx.detail.shipper_user)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 2,
              title: "下单用户",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, {
                  label: "ID",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.shipper_user?.id) + "（sn" + _toDisplayString(_ctx.detail?.shipper_user?.sn) + "） ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "头像" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image, {
                      src: _ctx.detail?.shipper_user?.avatar,
                      width: 50,
                      height: 50
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "姓名" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.shipper_user?.nickname) + " ", 1),
                    (_ctx.detail?.shipper_user?.sex === 1)
                      ? (_openBlock(), _createBlock(_component_man_outlined, {
                          key: 0,
                          style: {"color":"deepskyblue"}
                        }))
                      : (_openBlock(), _createBlock(_component_woman_outlined, {
                          key: 1,
                          style: {"color":"deeppink"}
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "联系电话" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.shipper_user?.mobile), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_9,
        (_ctx.detail && _ctx.detail.goods)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 3,
              title: "物流",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "货物类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.goods.goods_category_name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "体积" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.goods.volume + "m³"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "重量" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.goods.weight + "kg"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "收货信息",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.receiver.name) + "," + _toDisplayString(_ctx.detail?.receiver.phone), 1),
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.detail?.receiver.province_name) + _toDisplayString(_ctx.detail?.receiver.city_name) + _toDisplayString(_ctx.detail?.receiver.county_name) + _toDisplayString(_ctx.detail?.receiver.address), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "装货/寄货",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.shipper.name) + "," + _toDisplayString(_ctx.detail?.shipper.phone), 1),
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.detail?.shipper.province_name) + _toDisplayString(_ctx.detail?.shipper.city_name) + _toDisplayString(_ctx.detail?.shipper.county_name) + _toDisplayString(_ctx.detail?.shipper.address), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "备注",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.remark), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "接单时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.rob_time ? _ctx.dayjs(_ctx.detail?.rob_time * 1000).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "装货时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.loading_time ? _ctx.dayjs(_ctx.detail?.loading_time * 1000).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "送达时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.service_time ? _ctx.dayjs(_ctx.detail?.service_time * 1000).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "签收时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.sign_time ? _ctx.dayjs(_ctx.detail?.sign_time * 1000).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_12,
        (_ctx.routePathDetail && _ctx.willPathDetail)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 4,
              title: "轨迹",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "车辆已行驶" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.distanceFormatKm(_ctx.routePathDetail.distance)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.routePathDetail.steps && _ctx.routePathDetail.steps.length && _ctx.routePathDetail.steps[0].cities)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 0,
                      label: "最后一次更新车辆位置"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.routePathDetail.steps[_ctx.routePathDetail.steps.length - 1].cities[0].name +  _ctx.routePathDetail.steps[_ctx.routePathDetail.steps.length - 1].cities[0].districts[0].name), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.detail.status > 403)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 1,
                      label: "距终点"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 2,
                      label: "距终点"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.distanceFormatKm(_ctx.willPathDetail.distance)) + " ", 1),
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString("预计" + _ctx.timeCountFormat(_ctx.willPathDetail.time) + "后到达"), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
          [_vShow, _ctx.routePath && _ctx.routePath.length]
        ])
      ]),
      _: 1
    })
  ]))
}